import Typography from "../../../../../../../../common/Typography";

const PaymentSuccess = () => {
  return (
    <div className="payment-successfull-content">
      <iframe src="https://lottie.host/embed/b3fc729c-2435-4e40-87e5-03f92508aa33/MNfYUQyyVS.lottie" />
      <Typography
        size="display-xl"
        weight="medium"
        customClass="payment-successful-text"
      >
        Payment <br /> Successful
      </Typography>
    </div>
  );
};
export default PaymentSuccess;
